export default "__VITE_ASSET__BXf6km22__"